import assertNever from 'assert-never';
import { Guid } from '@ef-carbon/primitive';
import isIConditional from './isIConditional';
import isIDirect from './isIDirect';
import isIRandom from './isIRandom';
import isIRemote from './isIRemote';
import conditional from './process/conditional';
import direct from './process/direct';
import random from './process/random';
import remote from './process/remote';
function args(redirect, context, options) {
    if (context) {
        return {
            redirect: redirect ? new Guid(redirect) : undefined,
            context,
            options: options ? options : {}
        };
    }
    return {
        redirect: undefined,
        context: redirect ? redirect : {},
        options: {}
    };
}
export async function linkProcess(link, redirect, context, options) {
    const {
        context: ctx,
        redirect: redirection,
        options: opts
    } = args(redirect, context, options);
    if (redirection) {
        return {
            id: redirection,
            redirect: undefined,
            context: ctx
        };
    }
    if (isIConditional(link)) {
        return conditional(link, ctx, opts);
    } else if (isIDirect(link)) {
        return direct(link, ctx, opts);
    } else if (isIRandom(link)) {
        return random(link, ctx, opts);
    } else if (isIRemote(link)) {
        return remote(link, ctx, opts);
    } else {
        return assertNever(link);
    }
}
export {
    linkProcess as process
};
export default linkProcess;    //# sourceMappingURL=process.js.map
